module.exports = __webpack_public_path__ + "img/3-2.71fe76d9.png";